module.exports = __webpack_public_path__ + "static/event-hub-add-button-e904951f206cf5b7111adfd35b71c59e.png";